import { render, staticRenderFns } from "./SizeCheckRow.vue?vue&type=template&id=9243ff4a"
import script from "./SizeCheckRow.vue?vue&type=script&lang=js"
export * from "./SizeCheckRow.vue?vue&type=script&lang=js"
import style0 from "./SizeCheckRow.vue?vue&type=style&index=0&id=9243ff4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports